export const LOCALE_SWITCH = 'I18N/LOCALE_SWITCH';
export const LOCALE_SWITCH_SUCCESS = 'I18N/LOCALE_SWITCH_SUCCESS';
export const LOCALE_SWITCH_FAILURE = 'I18N/LOCALE_SWITCH_FAILURE';

export const FETCH_APP_TRANSLATIONS_REQUEST = 'I18N/APP/FETCH_TRANSLATIONS_REQUEST';

export const FETCH_TRANSLATIONS_REQUEST = 'I18N/FETCH_TRANSLATIONS_REQUEST';
export const FETCH_TRANSLATIONS_FAILURE = 'I18N/FETCH_TRANSLATIONS_FAILURE';
export const FETCH_TRANSLATIONS_SUCCESS = 'I18N/FETCH_TRANSLATIONS_SUCCESS';
